import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [tab, setTab] = useState('vendor');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = tab === 'admin'
        ? await authAPI.adminLogin(
            { email, password })
        : tab === 'customer'
        ? await authAPI.customerLogin(
            { email, password })
        : await authAPI.vendorLogin(
            { email, password });

      const { token, user } = res.data.data;
      login(user, token);
      navigate('/dashboard');
    } catch (err) {
      setError(
        err.response?.data?.message
        || 'Login failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh',
      background:'var(--bg)',
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      padding:'20px',
    }}>
      <div style={{
        width:'100%', maxWidth:'420px',
      }}>
        {/* Logo */}
        <div style={{
          textAlign:'center',
          marginBottom:'40px',
        }}>
          <img
            src="/logo512.png"
            alt="IRONWALL Service Bridge"
            style={{
              width:'72px', height:'72px',
              borderRadius:'16px',
              margin:'0 auto 16px',
              display:'block',
            }}
          />
          <h1 style={{
            fontFamily:'Syne,sans-serif',
            fontSize:'26px', fontWeight:'800',
            color:'var(--text)',
            marginBottom:'6px',
          }}>
            IRONWALL
          </h1>
          <p style={{
            fontSize:'13px',
            color:'var(--text3)',
            fontFamily:'DM Mono,monospace',
            letterSpacing:'1px',
          }}>
            SERVICE BRIDGE
          </p>
        </div>

        {/* Card */}
        <div style={{
          background:'var(--surface)',
          border:'1px solid var(--border)',
          borderRadius:'16px',
          padding:'32px',
        }}>
          {/* Tabs */}
          <div style={{
            display:'flex',
            background:'var(--surface2)',
            borderRadius:'10px',
            padding:'4px',
            marginBottom:'28px',
          }}>
            {['vendor','customer','admin'].map(t => (
              <button key={t}
                onClick={() => {
                  setTab(t);
                  setError('');
                }}
                style={{
                  flex:1, padding:'8px',
                  border:'none',
                  borderRadius:'8px',
                  cursor:'pointer',
                  fontSize:'13px',
                  fontWeight:'600',
                  transition:'all 0.15s',
                  background: tab === t
                    ? 'var(--accent)'
                    : 'transparent',
                  color: tab === t
                    ? 'var(--bg)'
                    : 'var(--text2)',
                }}
              >
                {t === 'vendor'
                  ? 'Vendor Login'
                  : t === 'customer'
                  ? 'Customer Login'
                  : 'Admin Login'}
              </button>
            ))}
          </div>

          {/* Form */}
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom:'16px' }}>
              <label style={{
                display:'block',
                fontSize:'11px',
                fontFamily:'DM Mono,monospace',
                color:'var(--text3)',
                letterSpacing:'1px',
                textTransform:'uppercase',
                marginBottom:'6px',
              }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e =>
                  setEmail(e.target.value)}
                required
                placeholder="you@company.com"
                style={{
                  width:'100%',
                  background:'var(--surface2)',
                  border:'1px solid var(--border2)',
                  color:'var(--text)',
                  padding:'11px 14px',
                  borderRadius:'8px',
                  fontSize:'14px',
                  outline:'none',
                }}
              />
            </div>

            <div style={{ marginBottom:'24px' }}>
              <label style={{
                display:'block',
                fontSize:'11px',
                fontFamily:'DM Mono,monospace',
                color:'var(--text3)',
                letterSpacing:'1px',
                textTransform:'uppercase',
                marginBottom:'6px',
              }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e =>
                  setPassword(e.target.value)}
                required
                placeholder="••••••••"
                style={{
                  width:'100%',
                  background:'var(--surface2)',
                  border:'1px solid var(--border2)',
                  color:'var(--text)',
                  padding:'11px 14px',
                  borderRadius:'8px',
                  fontSize:'14px',
                  outline:'none',
                }}
              />
            </div>

            {error && (
              <div style={{
                background:
                  'rgba(255,77,109,0.1)',
                border:
                  '1px solid rgba(255,77,109,0.3)',
                color:'var(--red)',
                padding:'12px 14px',
                borderRadius:'8px',
                fontSize:'13px',
                marginBottom:'16px',
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width:'100%',
                background: loading
                  ? 'var(--surface3)'
                  : 'var(--accent)',
                color: loading
                  ? 'var(--text3)'
                  : 'var(--bg)',
                border:'none',
                padding:'12px',
                borderRadius:'8px',
                fontSize:'14px',
                fontWeight:'700',
                cursor: loading
                  ? 'not-allowed' : 'pointer',
                transition:'all 0.15s',
              }}
            >
              {loading
                ? 'Signing in...'
                : 'Sign In →'}
            </button>
          </form>

          {(tab === 'vendor' || tab === 'customer') && (
            <p style={{
              textAlign:'center',
              marginTop:'20px',
              fontSize:'13px',
              color:'var(--text3)',
            }}>
              New {tab === 'vendor' ? 'vendor' : 'customer'}?{' '}
              <span
                onClick={() =>
                  navigate(tab === 'vendor'
                    ? '/register'
                    : '/customer-register')}
                style={{
                  color:'var(--accent)',
                  cursor:'pointer',
                }}
              >
                Register here
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;